export const obfuscateToken = (token: string) => {
  if (!token) {
    return '-';
  }
  const tokenObfuscated =
    token.slice(0, -4).replace(/./g, '*') + token.slice(-4);
  return tokenObfuscated.slice(-8);
};
